export default {
  fields: {
    country: 'Land van de bank',
    iban: 'IBAN',
    routing_number: 'Routingnummer',
    account_number: 'Rekeningnummer',
    sort_code: 'Sort code',
    account_type: 'Rekeningtype',
  },
  help: {
    country: 'Het land van de bank, dat kan afwijken van dat van het restaurant.',
  },
  placeholders: {
    iban: 'DE89 3704 0044 0532 0130 00',
  },
  formats: {
    uk_local: {
      title: 'Sort code en rekeningnummer',
      description: 'De gebruikelijke manier om een Britse rekening in te voeren.',
    },
    iban: {
      title: 'IBAN',
      description: 'Het internationale bankrekeningnummer.',
    },
    us_local: {
      title: 'Routing- en rekeningnummer',
      description: 'Een Amerikaanse bankrekening.',
    },
  },
  account_types: {
    checking: 'Betaalrekening',
    savings: 'Spaarrekening',
  },
  actions: {
    save: 'Bankrekening opslaan',
    cancel: 'Annuleren',
    edit: 'Bewerken',
  },
  card: {
    account: 'Rekening',
    country: 'Land',
    status: 'Status',
  },
  statuses: {
    active: 'Actief',
    pending_verification: 'Wordt geverifieerd',
    action_needed: 'Actie vereist',
    errored: 'Uitbetaling mislukt',
    missing: 'Ontbreekt',
  },
  notes: {
    pending_verification:
      'Adyen controleert elke bankrekening voordat uitbetalingen starten. Bevestig de rekening op de pagina van Adyen met een bankinlog of een bankafschrift.',
    action_needed:
      'De betalingsprovider kon deze bankrekening niet bevestigen. Controleer de gegevens of voer een andere rekening in.',
    errored:
      'Een uitbetaling naar deze rekening is mislukt en uitbetalingen zijn gepauzeerd. Controleer de gegevens of voer een andere rekening in.',
  },
};
